import React from "react";
import Dialog from "@mui/material/Dialog";
import { DialogContent, DialogTitle } from "@mui/material";
import { useDispatch, useSelector } from "react-redux";
import CloseIcon from "@mui/icons-material/Close";
import { handleHistoryCloseModal } from "../../redux/Reducer/ModalSlice";

function HistoryModal({ children, ModalWidth, ModalTitle }) {
  const history = useSelector((state) => state.Modal.openHistoryModal);
  const dispatch = useDispatch();

  return (
    <Dialog
      open={history}
      fullWidth={true}
      maxWidth={ModalWidth}
    >
      <DialogTitle sx={{ display: "flex", justifyContent: "space-between" }}>
        <span
          style={{
            color: "#4187e8",
          }}
        >
          {ModalTitle}
        </span>
        <CloseIcon
          sx={{ mt: "5px", cursor: "pointer" }}
          onClick={() => {
            dispatch(handleHistoryCloseModal());
          }}
        />
      </DialogTitle>
      <DialogContent dividers style={{ padding: "2rem" }}>
        {children}
      </DialogContent>
    </Dialog>
  );
}

export default HistoryModal;
